export default "__VITE_ASSET__B6O656UQ__"